module.exports = __webpack_public_path__ + "static/media/horn-icon.b3049417.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/horn-icon.svg
// module id = 776
// module chunks = 0